import { render, staticRenderFns } from "./DoneTemporary.vue?vue&type=template&id=fc2144a0&scoped=true"
import script from "./DoneTemporary.vue?vue&type=script&lang=js"
export * from "./DoneTemporary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2144a0",
  null
  
)

export default component.exports